import { IconName, MixpanelEvent, type ValueOf } from '@talos/kyoko';
import type { SoundMap } from './soundUtils';

export const AvailableSounds = {
  Filled_Order: 'Coins',
  Rejected_Order: 'Rejected',
  Canceled_Order: 'Canceled',
  Clear_Order: 'Swipe',
  RFQ_FirstPriceBack: 'RFQ_FirstPriceBack',
  RFQ_NewQuoteUpdatedQuote: 'RFQ_NewQuoteUpdatedQuote',
} as const satisfies Record<string, keyof typeof SoundMap>;
export type OrderTypeToSoundMapType = ValueOf<typeof AvailableSounds>;

export const INITIAL_SOUND_CONFIG = {
  [AvailableSounds.Filled_Order]: true,
  [AvailableSounds.Rejected_Order]: true,
  [AvailableSounds.Canceled_Order]: true,
  [AvailableSounds.Clear_Order]: true,
  [AvailableSounds.RFQ_FirstPriceBack]: false,
  [AvailableSounds.RFQ_NewQuoteUpdatedQuote]: false,
};

const BASE_SOUND_OPTIONS = [
  {
    name: 'Order Filled',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.Filled_Order,
    mixpanelEvent: MixpanelEvent.EnableOrderFilledSound,
  },
  {
    name: 'Order Rejected',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.Rejected_Order,
    mixpanelEvent: MixpanelEvent.OrderRejectedSound,
  },
  {
    name: 'Order Canceled',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.Canceled_Order,
    mixpanelEvent: MixpanelEvent.OrderCanceledSound,
  },
  {
    name: 'Order Archived',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.Clear_Order,
    mixpanelEvent: MixpanelEvent.OrderArchivedSound,
  },
] as const;

const RFQ_SOUND_OPTIONS = [
  {
    name: 'First price back on RFQ',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.RFQ_FirstPriceBack,
    mixpanelEvent: MixpanelEvent.FirstPriceBackOnRFQ,
  },
  {
    name: 'New quote/updated quote on RFQ',
    icon: IconName.VolumeUp,
    sound: AvailableSounds.RFQ_NewQuoteUpdatedQuote,
    mixpanelEvent: MixpanelEvent.NewQuoteUpdatedQuoteOnRFQ,
  },
] as const;

export const getSoundOptions = (featureFlags: { enableRfqSoundEffects?: boolean }) => {
  return featureFlags.enableRfqSoundEffects ? [...BASE_SOUND_OPTIONS, ...RFQ_SOUND_OPTIONS] : BASE_SOUND_OPTIONS;
};
